<template>
  <table class="ui-kit">
    <thead>
      <th class="ui-kit__name-col">Name</th>
      <th class="ui-kit__control-col">Control</th>
    </thead>
    <tbody>
      <tr class="ui-kit__row">
        <td>
          Stages Legend
        </td>
        <td>
          <button-el @click="switchStage">SwitchStage</button-el>
          <stages-legend :stages="stages" />
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>
          Dots spinner
        </td>
        <td>
          <dots-spinner />
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>
          Info Field
        </td>
        <td>
          <info-field text="Hello" label="Test" />
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>
          Currency Selector
        </td>
        <td>
          <currency-selector v-model="selectedCurrency" />
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>
          SearchControl
        </td>
        <td>
          <search-control placeholder="Currency name or ticker" @onResultClick="onEnterPress" @onEnterPress="onEnterPress"></search-control>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Button</td>
        <td>
          <button-el @click="onBtnClicked">Text</button-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Button align left</td>
        <td>
          <button-el left @click="onBtnClicked">Text</button-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Button align right</td>
        <td>
          <button-el right @click="onBtnClicked">Text</button-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Button red</td>
        <td>
          <button-el red @click="onBtnClicked">Text</button-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Button large</td>
        <td>
          <button-el large @click="onBtnClicked">Text</button-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Button disabled</td>
        <td>
          <button-el disabled @click="onBtnClicked">Text</button-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Input field</td>
        <td>
          <input-el v-model="inputValue" type="text" placeholder="placeholder" inputId="some-id"></input-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>textarea field</td>
        <td>
          <textarea-el v-model="inputValue" placeholder="placeholder"></textarea-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Head Title</td>
        <td>
          <head-title>Head Title</head-title>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>SelectBox</td>
        <td>
          <select-box v-model="selectboxValue" :options="selectboxOptions"></select-box>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Red word</td>
        <td>
          <red-text>Red word</red-text>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Green word</td>
        <td>
          <green-text>Green word</green-text>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Checkbox</td>
        <td>
          <checkbox-el name="name" id="checkbox1" val="1" v-model="checked">Black word</checkbox-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Checkbox disabled</td>
        <td>
          <checkbox-el name="name" id="checkbox3" disabled val="3">Black word</checkbox-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Switcher</td>
        <td>
          <switcher-el id="switcher" v-model="checked"></switcher-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Radio buttons</td>
        <td>
          <radio-el :radioValues="radioValues" v-model="radioChecked"></radio-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon Gear</td>
        <td>
          <icon-base red>
            <icon-gear />
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon magnifier</td>
        <td>
          <icon-base red>
            <icon-magnifier/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon cross</td>
        <td>
          <icon-base red>
            <icon-cross red/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon plus</td>
        <td>
          <icon-base red>
            <icon-plus-minus/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon minus</td>
        <td>
          <icon-base red>
            <icon-plus-minus minus/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
      <tr class="ui-kit__row">
        <td>Icon arrow min</td>
        <td>
          <icon-base red>
            <icon-arrow-min/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon arrow max</td>
        <td>
          <icon-base red>
            <icon-arrow-max red/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon arrow button</td>
        <td>
          <icon-base red>
            <icon-arrow-btn/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon question</td>
        <td>
          <icon-base red>
            <icon-question/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon check</td>
        <td>
          <icon-base red>
            <icon-check/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon lock</td>
        <td>
          <icon-base red>
            <icon-lock/>
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon star filled and not(click it)</td>
        <td>
          <icon-star :fill="filledStar" @click.native="onStarClick"/>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon tendency arrow down</td>
        <td>
          <icon-tendency-arrow/>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon tendency arrow top green</td>
        <td>
          <icon-tendency-arrow up/>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Icon infinity</td>
        <td>
          <icon-base red>
            <icon-infinity />
          </icon-base>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Tooltip</td>
        <td>
          <tooltip @mouseover="onHoverIcon">
            It is a method of augmenting the behaviour of a web page with custom callbacks. These callbacks may be maintained, modified, and managed by third-party users and developers
          </tooltip>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Round btn(edit)</td>
        <td>
          <round-btn @click="onBtnClicked">
            <icon-base red>
              <icon-pencil />
            </icon-base>
          </round-btn>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Round btn(can use with any icon)</td>
        <td>
          <round-btn @click="onBtnClicked">
            <icon-base red>
              <icon-refresh />
            </icon-base>
          </round-btn>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Load more btn</td>
        <td>
          <load-more-btn @click="onBtnClicked" />
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Table Red</td>
        <td>
          <table-el red>
            <tr slot="thead">
              <th>red Table head</th>
              <th>red Table head</th>
              <th>red Table head</th>
            </tr>
            <tr slot="tbody">
              <td>Text</td>
              <td>Text</td>
              <td>Text</td>
            </tr>
            <tr slot="tbody">
              <td>Text</td>
              <td>Text</td>
              <td>Text</td>
            </tr>
          </table-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Table gray</td>
        <td>
          <table-el gray>
            <tr slot="thead">
              <th>GRAY table head</th>
              <th>GRAY table head</th>
              <th>GRAY table head</th>
            </tr>
            <tr slot="tbody">
              <td>Text</td>
              <td>Text</td>
              <td>Text</td>
            </tr>
            <tr slot="tbody">
              <td>Text</td>
              <td>Text</td>
              <td>Text</td>
            </tr>
          </table-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Red label</td>
        <td>
          <red-label>
          SMS and Email are unabled because your phone and email are not confirmed!
          <button-el class="alert__btn" red>CONFIRM</button-el>
          </red-label>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Add plus for value</td>
        <td>
          <percent-trend :value="123456"/>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>List</td>
        <td>
          <list-el>
            <li>Item 1</li>
            <li>Item 2</li>
            <li>Item 3</li>
            <li>Item 4</li>
            <li>Item 5</li>
          </list-el>
        </td>
      </tr>
      <tr class="ui-kit__row">
        <td>Square button</td>
        <td>
          <square-btn>
            <icon-base red>
              <icon-infinity />
            </icon-base>
          </square-btn>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import {
  IconGear,
  IconMagnifier,
  IconCross,
  IconPlusMinus,
  IconArrowMin,
  IconArrowBtn,
  IconQuestion,
  IconCheck,
  IconLock,
  IconArrowMax,
  IconStar,
  IconPencil,
  IconRefresh,
  IconTendencyArrow,
  IconInfinity } from 'Icons';
import stagesSwitchersMixin from 'src/mixins/stagesSwitchers';

export default {
  mixins: [
    stagesSwitchersMixin,
  ],
  components: {
    IconGear,
    IconMagnifier,
    IconCross,
    IconPlusMinus,
    IconArrowBtn,
    IconQuestion,
    IconCheck,
    IconLock,
    IconArrowMax,
    IconArrowMin,
    IconStar,
    IconPencil,
    IconRefresh,
    IconTendencyArrow,
    IconInfinity,
  },
  data() {
    return {
      stages: [
        {
          name: 'Configuration1',
          finished: false,
          active: true,
        },
        {
          name: 'Configuration2',
          finished: false,
          active: false,
        },
        {
          name: 'Configuration3',
          finished: false,
          active: false,
        },
      ],
      filledStar: false,
      inputValue: '1',
      checked: true,
      radioValues: [
        {
          name: 'radio1',
          id: 'radio1',
          value: 'case 1',
          text: 'case 1 2 3',
        },
        {
          name: 'radio2',
          id: 'radio2',
          value: 'case 2',
          checkedDefault: true,
        },
        {
          name: 'radio3',
          id: 'radio3',
          value: 'case 3',
          disabled: true,
        },
      ],
      radioChecked: null,
      selectboxValue: null,
      selectboxOptions: [
        { value: 'One', name: 'one' },
        { value: 'Two', name: 'two' },
      ],
      selectedCurrency: {
        percentChange24hUSD: 1.36,
        percentChange1hUSD: -0.5,
        marketCapUSD: 118080588939,
        marketVol24hUSD: 3790860000,
        priceUSD: 6960.37,
        ticker: 'BTC',
        name: 'Bitcoin',
      },
    };
  },
  methods: {
    switchStage() {
      const lastIsActive = this.stages[this.stages.length - 1].active;
      if (lastIsActive) {
        this.goPrevStage();
      } else {
        this.goNextStage();
      }
    },
    onEnterPress(row) {
      //eslint-disable-next-line
      console.log(row);
    },
    onBtnClicked() {
      //eslint-disable-next-line
      console.log('Button is clicked');
    },
    onStarClick() {
      this.filledStar = !this.filledStar;
    },
    onHoverIcon() {
      //eslint-disable-next-line
      console.log('123');
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-kit {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  border-collapse: collapse;
  &__name-col {
    width: 20%;
  }
  &__control-col {
    width: 80%;
  }
  th {
    text-align: left;
  }
  td {
    border-top: 1px solid $grey-color4;
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/UiKit.vue